import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useEnableUsers = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const enableUsers = async (userIds: string[]) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: { userIds },
    });

    const response = await fetch(`${APIBaseChronos}/api/user/enable`, fetchConfig);

    if (!response.ok) {
      throw new Error(`Failed to enable users: ${response.status}`);
    }
  };

  return useMutation({
    mutationFn: enableUsers,
    onSuccess: () => {
      toast.success('Users unblocked successfully');
      queryClient.invalidateQueries([QueryEntity.Users]);
      queryClient.invalidateQueries([QueryEntity.User]);
    },
    onError: () => {
      toast.error('Failed to unblock users');
    },
  });
};
